import script from "./TorneoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TorneoCard.vue?vue&type=script&setup=true&lang=ts"

import "./TorneoCard.vue?vue&type=style&index=0&id=1e84e807&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e84e807"]])

export default __exports__